export default {
    PITCH: 'pitch',
    RESULT: 'result',
    RESULT_NO_IN_PLAY: 'resultNoInPlay',
    PITCH_WITH_RESULT: 'pitchWithResult',
    NONE: 'none'
};
